const purchaseHistoryDE = {
    "view": {
        "table": {
            "title": "Ihr Kaufverlauf",
            "column": {
                "amount": "Betrag",
                "description": "Beschreibung",
                "credits_balance": "Guthabenstand",
                "tokens_balance": "Token-Guthaben",
                "date_of_purchase": "Kaufdatum",
                "receipt": "Beleg"
            },
            "placeholder": {
                "search": "Suchen..."
            },
            "button": {
                "view": "Ansehen",
                "export_csv": "CSV exportieren"
            }
        }
    }
};

export default purchaseHistoryDE;